(function ($) { 

    Drupal.behaviors.paymentFormRedirect = {

        attach: function (context) {
            
            $(".paymentFormRedirect").each(function(){

                $(this).find(".countdown").html("3");
                setTimeout(function(){
                    $(".paymentFormRedirect").find(".countdown").html("2");
                }, 1000);
                setTimeout(function(){
                    $(".paymentFormRedirect").find(".countdown").html("1");
                }, 2000);
                setTimeout(function(){
                    $(".paymentFormRedirect").find(".countdown").hide();
                    $(".preloader").show();
                    $(".paymentFormRedirect").find("form").submit();
                }, 3000);
                setTimeout(function(){
                    $(".preloader").hide();
                    $(".paymentFormRedirect").find("form").css("opacity", 1);
                }, 10000);
            });
        }
    }

})(jQuery);